var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"floating-box"},[_c('img',{class:{ floating: true, move: !_vm.iconClass },attrs:{"src":require("../assets/floating.jpg"),"alt":"悬浮框","title":"点击咨询"},on:{"click":_vm.consult}}),_c('i',{class:[
      'icon',
      _vm.iconClass ? 'el-icon-d-arrow-right' : 'el-icon-d-arrow-left',
    ],on:{"click":_vm.close}})])
}
var staticRenderFns = []

export { render, staticRenderFns }